import { creatorbase } from '@round/api';
import { showNotification } from 'helpers';
import { backupPostsStatuses } from 'Modules/Plans/Posts/helpers';
import copyComponentRenderToClipboard from 'utility/copyToClipboard/copyComponentRenderToClipboard';
import InstagramReportClipboardTable, {
    mapToClipboardReportRow,
    mapToClipboardReportTotals,
} from 'Modules/Plans/CopyToClipboard/projectReport/InstagramReportClipboardTable';
import useProjectDetails from '../../useProjectDetails';
import { CampaignTableRow } from '../../components/ProjectCampaignsTable/ProjectCampaignsTable';
import { useEnsureProjectDetailsInstagramPosts } from '../posts/useProjectDetailsInstagramPosts';

export default function useCopyInstagramReportToClipboard() {
    const ensurePosts = useEnsureProjectDetailsInstagramPosts();
    const { project, brand } = useProjectDetails();

    return async (campaign: CampaignTableRow, includeCost: boolean) => {
        try {
            const rows = await ensurePosts(campaign.id);

            const items = rows
                .filter((row) => !backupPostsStatuses.includes(row.status as creatorbase.BackupPostStatus))
                .map((row) =>
                    mapToClipboardReportRow({
                        post: row,
                        user: row.user ?? null,
                        userStats: row.userStatsCache ?? null,
                    })
                );

            const totals = mapToClipboardReportTotals(
                campaign.stats,
                items,
                campaign as unknown as creatorbase.InstagramCampaign
            );
            const success = copyComponentRenderToClipboard(
                {
                    artistName: brand?.name,
                    projectName: project?.name,
                    campaignName: campaign.name,
                    currency: campaign.currency,
                    totals,
                    items,
                    includeCost,
                },
                InstagramReportClipboardTable
            );

            showNotification(success ? 'Copied!' : 'Could not copy', success ? 'info' : 'error');
        } catch {
            showNotification('Could not copy', 'error');
        }
    };
}
